export default __webpack_public_path__ + "static/media/iAssets.9578abac.png";